var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTiktok(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 29,
    viewBox: "0 0 25 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.0144 11.7405C22.6608 11.8666 21.2985 11.6219 20.0734 11.0326C18.8483 10.4433 17.8067 9.5317 17.0604 8.39546V19.905C17.0604 24.6032 13.2475 28.4108 8.54125 28.4108C3.83504 28.4108 0.020752 24.6032 0.020752 19.905C0.020752 15.2068 3.83504 11.3992 8.53992 11.3992C8.71856 11.3992 8.89321 11.4152 9.06786 11.4258V15.6174C8.89321 15.5961 8.72123 15.5641 8.54125 15.5641C7.97056 15.5636 7.40535 15.6755 6.87791 15.8934C6.35048 16.1114 5.87114 16.4311 5.46729 16.8343C5.06344 17.2376 4.74299 17.7164 4.52423 18.2435C4.30547 18.7706 4.19269 19.3356 4.19234 19.9063C4.19287 20.4769 4.30577 21.0418 4.52461 21.5687C4.74345 22.0957 5.06393 22.5744 5.46776 22.9775C5.8716 23.3806 6.35087 23.7002 6.87822 23.918C7.40557 24.1359 7.97067 24.2478 8.54125 24.2472C10.9423 24.2472 13.0648 22.3581 13.0648 19.9597L13.1061 0.413574H17.1231C17.308 2.15726 18.0999 3.78049 19.3603 4.99949C20.6207 6.21849 22.2695 6.9557 24.0184 7.08225V11.7405",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiktok);
export default __webpack_public_path__ + "static/media/tiktok.3a5fea6a62b9dbc2ffffa30638ff6d17.svg";
export { ForwardRef as ReactComponent };